import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Diversity1Icon(props: IconProps) {
    return <Icon {...props} iconKey={"diversity_1"}/>
}
